import { loadTossPayments } from '@tosspayments/payment-sdk';

/**
 * 토스 페이먼츠 결제 수단 변경(빌링키 인증) 재사용 훅
 * - ModalUsingPlan, Gnb 등에서 공통으로 사용
 */
const useTossPayment = () => {
    const requestCardChange = async (customerId: string) => {
        const clientKey =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_TOSS_TEST_CLIENT_KEY
                : process.env.REACT_APP_TOSS_LIVE_CLIENT_KEY;

        const successUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_LOCAL_CHANGE_PAY_INFO_SUCCESS_URL
                : process.env.REACT_APP_PROD_CHANGE_PAY_INFO_SUCCESS_URL;

        const failUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_LOCAL_CHANGE_PAY_INFO_FAIL_URL
                : process.env.REACT_APP_PROD_CHANGE_PAY_INFO_FAIL_URL;

        const tossPayments = await loadTossPayments(clientKey as string);
        tossPayments
            .requestBillingAuth('카드', {
                customerKey: customerId,
                successUrl: successUrl as string,
                failUrl: failUrl as string,
            })
            .catch((error) => {
                console.log(error.code);
            });
    };

    return { requestCardChange };
};

export default useTossPayment;
